angular
	.module 'App.Repository'
.factory 'CustomerPrefixRepository', ['BaseRepository', (BaseRepository) ->
	class CustomerPrefixRepository extends BaseRepository
		@resource = '/customer_prefixes'
		@isRestricted = true

		findByQuery: (query = null) ->
			if _.isEmpty(query)
				query = @createQuery()

			if !query.isSorted()
				query.sortBy 'name', 'ASC'

			super query

	return new CustomerPrefixRepository
]
